/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import moment from 'moment';
import { Row, Col, Button, Typography, Divider } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { ReactComponent as VideoCameraSvg } from '../../../assets/icons/appointment/video-camera.svg';
import { ReactComponent as CalendarWhiteSvg } from '../../../assets/icons/appointment/calendar-white.svg';
import { ReactComponent as ClockCircleSvg } from '../../../assets/icons/appointment/clock-circle.svg';

const { Title } = Typography

const styles = {
  box: {
    background: "#FFFFFF",
    border: "1px solid #EAEAEA",
    boxSizing: "border-box",
    padding: 12,
    marginBottom: 18
  },
  doctor: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#262626",
    margin: 0,
    marginRight: 10
  },
  date: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "22px",
    color: "#404047",
    margin: 0,
    marginRight: 10
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  time: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "22px",
    color: "#404047",
    margin: 0,
    marginRight: 10
  }
}

const MobileAppointmentItem = ({onClick, doctor, date, time, start}) => {
  const { t } = useTranslation(['common']);
  return (
    <Box style={styles.box}>
      <Row justify="center">
        <Col xs={12} >
          <Row align="middle" justify="start">
            <VideoCameraSvg style={{ marginRight: 10}} />
            <Title level={4} style={styles.doctor}>
              {doctor ?? 'Not Set'}
            </Title>
          </Row>
        </Col>
        <Col xs={12} >
          <Row align="middle" justify="end">
            {
              start === "" && (
                <Button
                  htmlType="button"
                  type="primary"
                  size="small"
                  onClick={onClick}
                >
                  <p style={styles.rowButton}>
                    {t('common:button.viewNotes')} <RightOutlined style={{ marginLeft: 10}}/>
                  </p>
                </Button>
              )
            }
            {
              start !== "" && (
                <Button
                  htmlType="button"
                  type="primary"
                  size="small"
                >
                  {start}
                </Button>
              )
            }
          </Row>
        </Col>
      </Row>
      <Divider />
      <Row justify="center">
        <Col xs={12} >
          <Row align="left" justify="start">
            <CalendarWhiteSvg style={{ marginRight: 10}} />
            <Title level={4} style={styles.date}>
              {moment(date).format('dddd DD MMMM YYYY')}
            </Title>
          </Row>
        </Col>
        <Col xs={12} >
          <Row align="middle" justify="end">
            <ClockCircleSvg style={{ marginRight: 10}} />
            <Title level={4} style={styles.time}>
            {moment(time).format('hh:mm a')}
            </Title>
          </Row>
        </Col>
      </Row>
    </Box>
  )
}

MobileAppointmentItem.defaultProps = {
  onClick: () => null,
  start: ''
};

const { func, string } = PropTypes;

MobileAppointmentItem.propTypes = {
  onClick: func,
  doctor: string,
  date: string,
  time: string,
  start: string
};

export default MobileAppointmentItem;
